import { formatTimer } from '@/shared/lib'
import { useSoundscapePlayer } from '../model/player-store'

// Таймлайн режима: где идёт суточный микс и куда его перемотать. Точка возврата
// уезжает на сервер, поэтому «дослушал до сюда» переживает и перезагрузку, и
// смену машины. Молчащий плеер полосы не рисует — перематывать нечего.
export function SoundscapeTimeline() {
  const { slug, title, position, duration, seek } = useSoundscapePlayer()

  if (!slug || duration <= 0) return null

  return (
    <div className="flex w-full items-center gap-3">
      <span data-numeric className="mono-num w-16 shrink-0 text-xs text-text-secondary">
        {formatTimer(Math.floor(position))}
      </span>
      <input
        type="range"
        min={0}
        max={Math.floor(duration)}
        step={1}
        value={Math.min(Math.floor(position), Math.floor(duration))}
        onChange={(e) => seek(Number(e.target.value))}
        aria-label={`Перемотка «${title}»`}
        className="range-thin min-w-0 flex-1"
      />
      <span data-numeric className="mono-num w-16 shrink-0 text-right text-xs text-text-tertiary">
        {formatTimer(Math.floor(duration))}
      </span>
    </div>
  )
}
